<template>
  <template v-if="editMode">
    <div class="message-placeholder-container">
      <div class="medium-message-placeholder">
        <iText v-bind="fullTextOptionsAttributes" :style-overrides="fullTextOptionsAttributes.textStyleOverrides">
          Article Title Input Placeholder
        </iText>
      </div>
    </div>
  </template>
  <iTextEditInput
    v-else
    ref="title"
    :model-value="title"
    :min-width="250"
    placeholder="Untitled Story"
    editable-on-click
    width="fill"
    hide-cta-buttons
    auto-save-on="input"
    hide-borders
    v-bind="fullTextOptionsAttributes"
    inline
    @submit="setTitle($event)"
  />
</template>

<script>
import {
  ArticleEditorElementMixin,
} from "%/dynamic-component-editor/standard-elements/articles/shared/article-editor-element-mixin";
import { TextElementMixin } from "%/dynamic-component-editor/standard-elements/text-element/text-element-mixin";

export default {
  name: "ArticleTitleInput",
  elementPanelSettings: {
    displayName: "Title Input",
    displayIcon: "pencil",
    elementGroup: "articleElements",
    elementType: "element",
  },
  mixins: [ArticleEditorElementMixin, TextElementMixin],
};
</script>

<style scoped lang="scss">
</style>
